import { render, staticRenderFns } from "./fnfPayslipPopup.vue?vue&type=template&id=9ca90b6e&scoped=true"
import script from "./fnfPayslipPopup.vue?vue&type=script&lang=js"
export * from "./fnfPayslipPopup.vue?vue&type=script&lang=js"
import style0 from "./fnfPayslipPopup.vue?vue&type=style&index=0&id=9ca90b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca90b6e",
  null
  
)

export default component.exports